const CHECKBOX_REGEX = /\[(x|X|\s)\]\s(.*)?/i;

const matches = token => token.content.match(CHECKBOX_REGEX);

function looksLikeChecklist(tokens, index) {
  return (
      tokens[index].type === 'inline' &&
      tokens[index - 1].type === 'paragraph_open' &&
      tokens[index - 2].type === 'list_item_open' &&
      matches(tokens[index])
  );
}

function parentTokenBefore(tokens, index) {
  const targetLevel = tokens[index].level - 1;
  for (let i = index - 1; i >= 0; i--) {
    if (tokens[i].level === targetLevel) {
      return i;
    }
  }
  return -1;
}

function parentTokenAfter(tokens, index) {
  const targetLevel = tokens[index].level - 1;
  for (let i = index + 1; i < tokens.length; i++) {
    if (tokens[i].level === targetLevel) {
      return i;
    }
  }
  return -1;
}

export const markdownCheckboxes = md => {
  md.core.ruler.after('inline', 'checkboxes', state => {
    const tokens = state.tokens;
    for (let i = 3; i < tokens.length; i++) {
      const matches = looksLikeChecklist(tokens, i);
      if (matches) {
        const checked = matches[1].toLowerCase() === 'x';

        const parentTokenOpen = parentTokenBefore(tokens, i - 2);
        if (tokens[parentTokenOpen].type === 'bullet_list_open' ||
            tokens[parentTokenOpen].type === 'ordered_list_open') {
          tokens[parentTokenOpen].type = 'checkbox_list_open';
        }

        const parentTokenClose = parentTokenAfter(tokens, i + 2);
        if (tokens[parentTokenClose].type === 'bullet_list_close' ||
            tokens[parentTokenClose].type === 'ordered_list_close') {
          tokens[parentTokenClose].type = 'checkbox_list_close';
        }

        const tokenChildren = tokens[i].children;
        if (tokenChildren) {
          const contentMatches = tokenChildren[0].content.match(CHECKBOX_REGEX);

          if (contentMatches) {
            const label = contentMatches[2];

            tokens[i].content = label;
            tokenChildren[0].content = label;
          }
        }

        tokens[i - 2].type = 'checkbox_item_open';
        if (checked === true) {
          tokens[i - 2].attrs = [['checked', 'true']];
        }

        let j = i;
        while (tokens[j].type !== 'list_item_close') {
          j++;
        }
        tokens[j].type = 'checkbox_item_close';
      }
    }

    return false;
  });
};
